import {
  fetchGetIncreaseBetsPositionsCountByAnnouncement,
  TGetIncreaseBetsPositionsCountByAnnouncementResponse,
} from '../../../repositories/auction/v2/get-increase-bets-positions-count-by-announcement';
import { mapSuccessResponse } from './utils';
import { IGetBetPositionParams, TGetBetPositionResult } from './types';
import { EBetPositionErrorCode } from '../../../redux/reducers';

export async function getBetPosition(params: IGetBetPositionParams): Promise<TGetBetPositionResult> {
  const { httpApi, logger, cookies, parameters } = params;

  const headers: [string, string][] = cookies ? [['Cookie', cookies]] : [];

  const config = {
    requestConfig: { headers },
  };

  try {
    // tslint:disable-next-line: max-line-length
    const response: TGetIncreaseBetsPositionsCountByAnnouncementResponse = await fetchGetIncreaseBetsPositionsCountByAnnouncement(
      {
        httpApi,
        parameters,
        config,
      },
    );

    if (response.statusCode === 200) {
      return {
        success: true,
        payload: mapSuccessResponse(response.response),
      };
    }
  } catch (error) {
    logger.error(error, {
      description: 'Запрос get-increase-bets-positions-count-by-announcement на ФП',
      degradation: 'Пользователь не увидит позицию объявления на карточке ФВУ',
    });
  }

  return {
    success: false,
    payload: EBetPositionErrorCode.serverError,
  };
}
